import { useEffect, useState } from "react";

/**
 * Milliseconds since `startedAt`, ticking once a second.
 *
 * `startedAt` is 0 while the turn is idle — there is nothing to count from, so this
 * returns 0 and starts no timer. Shared by `AnimationSlot` and `ThinkingIndicator`
 * because both need the exact same "is this turn taking a while?" cue, and computing
 * it twice, on two different clocks, would let them drift apart.
 */
const useElapsed = (startedAt: number): number => {
  const [now, setNow] = useState(() => (startedAt ? Date.now() : 0));

  useEffect(() => {
    if (!startedAt) {
      setNow(0);
      return;
    }
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [startedAt]);

  return startedAt ? Math.max(0, now - startedAt) : 0;
};

export default useElapsed;
